import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { selectPokerGames, selectGamesLoading } from '@/store/games/selectors';
import GamesStreamlineSection, {
  GamesStreamlineType,
} from '@/components/shared/games/GamesStreamlineSection';
import { BffGamesCategory } from '@lucky7ventures/bff-types';
import GamesSectionHeader from '@/pages/games/lobby/lobby-sections-streamlines/GamesSectionHeader';
import GamesSection from '@/pages/games/lobby/lobby-sections-streamlines/GamesSection';

const Poker = () => {
  const games = useSelector(selectPokerGames);
  const loading = useSelector(selectGamesLoading);
  const intl = useIntl();

  if (games.length === 0 && !loading) return null;

  return (
    <GamesSection>
      <GamesSectionHeader
        title={intl.formatMessage({ id: 'games.categories.poker' })}
        totalGames={games.length}
        categoryPath="/games/poker"
      />
      <GamesStreamlineSection
        type={GamesStreamlineType.Single}
        visibleGames={18}
        loading={loading}
        games={games}
        category={BffGamesCategory.Poker}
      />
    </GamesSection>
  );
};

export default Poker;
